import { isExperienceProduct, isMembershipProduct, isPackageProduct, isPartnerPackageProduct } from "common";
import React from "react";
import { Product } from "types";
import { CreatePurchaseExperienceFields } from "./CreatePurchaseExperienceFields";
import { CreatePurchaseSharedPackageFields } from "./CreatePurchaseSharedPackageFields";
import { CreatePurchaseMembershipFields } from "./Membership/CreatePurchaseMembershipFields";
import { isSharedDemographicsPackage } from "@/models/Package";
import { useCreatePurchaseStore } from "@/stores/createPurchaseStore";

interface CheckoutPurchaseProductFieldsProps {
    product: Product;
}

export const CheckoutPurchaseProductFields = React.memo(({ product }: CheckoutPurchaseProductFieldsProps) => {
    const isOneStepCheckout = useCreatePurchaseStore((state) => state.isOneStepCheckout());
    const isExperience = isExperienceProduct(product);
    const isMembership = isMembershipProduct(product);
    const isPackage = isPackageProduct(product) || isPartnerPackageProduct(product);
    const isSharedDemographicPackage = isSharedDemographicsPackage(product);

    return (
        <div className="space-y-4">
            {isOneStepCheckout && isExperience && <CreatePurchaseExperienceFields experience={product} />}

            {isPackage && isSharedDemographicPackage && <CreatePurchaseSharedPackageFields pkg={product} />}

            {isOneStepCheckout && isMembership && <CreatePurchaseMembershipFields membership={product} />}
        </div>
    );
});
